import React, { useEffect, useState } from "react";
import {
  NumericRangeFilter,
  PriceFilterOption,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { RangeSlider } from "../../components/range_slider";
import { formatCurrency } from "../../helpers/format_currency";
import styles from "../filter_sidebar.module.sass";

export type PriceRangeFilterControlsProps = {
  appliedPriceFilter?: NumericRangeFilter;
  priceRange: PriceFilterOption;
  onChange: (newValue: [number, number]) => void;
};

export const PriceRangeFilterControls = ({
  appliedPriceFilter,
  priceRange,
  onChange,
}: PriceRangeFilterControlsProps) => {
  const [inProgressValue, setInProgressValue] = useState<[number, number]>(
    () => {
      if (appliedPriceFilter) {
        return [appliedPriceFilter.gte, appliedPriceFilter.lte];
      } else {
        return [priceRange.min, priceRange.max];
      }
    }
  );

  useEffect(() => {
    if (appliedPriceFilter !== undefined) {
      setInProgressValue([appliedPriceFilter.gte, appliedPriceFilter.lte]);
    } else {
      setInProgressValue([priceRange.min, priceRange.max]);
    }
  }, [appliedPriceFilter, priceRange]);

  useEffect(() => {
    if (appliedPriceFilter !== undefined) {
      setInProgressValue([
        Math.max(appliedPriceFilter.gte, priceRange.min),
        Math.min(appliedPriceFilter.lte, priceRange.max),
      ]);
    }
  }, [priceRange]);

  if (priceRange.min === null || priceRange.max === null) {
    return null;
  }

  return (
    <fieldset>
      <div className="range-filter">
        <strong className={styles.priceHeadline}>Cena </strong>
        <div className="title">
          <span>
            od <em>{formatCurrency(inProgressValue[0])}</em> do{" "}
            <em>{formatCurrency(inProgressValue[1])}</em>
          </span>
        </div>

        <RangeSlider
          min={priceRange.min}
          max={priceRange.max}
          defaultValue={[priceRange.min, priceRange.max]}
          value={inProgressValue}
          onAfterChange={onChange}
          onChange={setInProgressValue}
        />
      </div>
    </fieldset>
  );
};
